import Vue from "vue";
import Vuex from "vuex";

import User from "./modules/UserVuex.js";
import App from "./modules/AppVuex.js";
import Notification from "./modules/NotificationVuex.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    App,
    User,
    Notification,

  }
});

export default store;
